import { render, staticRenderFns } from "./PurchaseDetailQuery.vue?vue&type=template&id=436c917c&scoped=true"
import script from "./PurchaseDetailQuery.vue?vue&type=script&lang=js"
export * from "./PurchaseDetailQuery.vue?vue&type=script&lang=js"
import style0 from "./PurchaseDetailQuery.vue?vue&type=style&index=0&id=436c917c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436c917c",
  null
  
)

export default component.exports